import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { EmptyState } from '~/components/component-library/EmptyState'
import { TransactionTitle } from '~/components/component-library/TransactionTitle'
import { TransactionDisplay } from '~/components/txn-display'
import { useSmartAccount } from '~/hooks/useSmartAccounts'
import { useOrgTransaction } from '~/hooks/useTransactions'
import { useDialogRoutePath } from '~/hooks/utils'
import { OrgTransaction } from '~/types'

export const dialogTitleClassName =
  'w-full text-ellipsis text-wrap text-base font-medium'

export const TransactionDetailDialogContent = ({
  transaction: transactionProp,
  onClose,
  globalModal,
}: {
  transaction: OrgTransaction
  onClose: () => void
  globalModal?: boolean
}) => {
  // Transaction prop is the transaction passed from the feed, but the latest transaction
  // is the one from the query.
  const { transaction: latestTransaction } = useOrgTransaction(
    transactionProp.id,
  )
  const transaction = latestTransaction ?? transactionProp

  const { smartAccount } = useSmartAccount(transaction.smartAccountAddress)

  useDialogRoutePath({
    closeModal: onClose,
    globalModal,
    getPath: () => {
      if (transaction && smartAccount) {
        return `/accounts/${smartAccount.address}/transactions/${transaction.id}/`
      }
    },
  })

  return (
    <SplitsDialogContent
      id="transactionDetailsDialog"
      title={
        <TransactionTitle
          transaction={transaction}
          className={dialogTitleClassName}
          textWrap
        />
      }
      variant="info"
      clampTitle={false}
    >
      {!smartAccount ? (
        <EmptyState title="Transaction not found" />
      ) : (
        <TransactionDisplay transaction={transaction} />
      )}
    </SplitsDialogContent>
  )
}
